import React from 'react';
import PropTypes from 'prop-types';

var Tail = function Tail(_ref) {
  var children = _ref.children,
      minimized = _ref.minimized;
  return /*#__PURE__*/React.cloneElement(children, {
    minimized: minimized
  });
};

Tail.displayName = 'Page.Tail';
Tail.propTypes = {
  children: PropTypes.element.isRequired,
  minimized: PropTypes.bool
};
export default Tail;